import React from "react";

function Icon() {
  return (
    <svg
      className="footerLogoImg"
      xmlns="http://www.w3.org/2000/svg"
      width="150"
      height="90"
      version="1.1"
      viewBox="0 0 150 90"
    >
      <g>
        <text
          style={{
            fontStyle: "normal",
            fontVariant: "normal",
            fontWeight: "normal",
            fontStretch: "normal",
            fontSize: "8.56886px",
            fontFamily: "Arial",
            display: "inline",
            opacity: 1,
            fill: "#ffffff",
            fillOpacity: 1,
            stroke: "none",
            strokeWidth: 0.267776,
            strokeOpacity: 1
          }}
          x="25.364792"
          y="60.23354"
          transform="scale(1.0120693,0.98807463)"
        >
          <tspan
            style={{
              fill: "#ffffff",
              fillOpacity: 1,
              strokeWidth: 0.267776
            }}
            x="25.364792"
            y="60.23354"
          >
            MINORITY AND WOMEN
          </tspan>
          <tspan
            style={{
              fill: "#ffffff",
              fillOpacity: 1,
              strokeWidth: 0.267776
            }}
            x="25.364792"
            y="70.944618"
          />
        </text>
        <text
          style={{
            fontStyle: "normal",
            fontVariant: "normal",
            fontWeight: "normal",
            fontStretch: "normal",
            fontSize: "8.02345px",
            fontFamily: "Arial",
            display: "inline",
            opacity: 1,
            fill: "#ffffff",
            fillOpacity: 1,
            stroke: "none",
            strokeWidth: 0.273526,
            strokeOpacity: 1
          }}
          x="32.295837"
          y="66.000633"
          transform="scale(0.95288805,1.0494412)"
        >
          <tspan
            style={{
              fontSize: "8.02345px",
              fill: "#ffffff",
              fillOpacity: 1,
              strokeWidth: 0.273526
            }}
            x="32.295837"
            y="66.000633"
          >
            BUSINESS ENTERPRISE
          </tspan>
        </text>
        <path
          style={{
            opacity: 1,
            fill: "#ffffff",
            fillOpacity: 1,
            stroke: "none",
            strokeWidth: 0.264583,
            strokeOpacity: 1
          }}
          d="m 12.676829,48.723867 c -0.08624,-0.431184 0.08624,-28.803135 0.08624,-28.803135 h 11.900697 l 6.295296,19.058362 6.467769,-18.972125 h 11.641987 l 0.08624,28.97561 -7.847563,-0.08624 0.517422,-21.904179 -7.416376,21.904179 -7.243903,-0.08624 -6.985191,-21.817943 0.08624,21.904179 z"
        />
        <path
          style={{
            opacity: 1,
            fill: "#ffffff",
            fillOpacity: 1,
            stroke: "none",
            strokeWidth: 0.264583,
            strokeOpacity: 1
          }}
          d="m 49.844949,20.093206 6.467768,28.716899 10.003486,0.08624 3.794424,-21.990418 4.22561,21.990418 9.917247,-0.08624 6.381533,-28.889373 -7.502612,-0.08624 -3.708188,21.990417 -4.22561,-21.731706 h -9.917248 l -3.708188,21.64547 -3.9669,-21.817944 z"
        />
        <path
          style={{
            opacity: 1,
            fill: "#ffffff",
            fillOpacity: 1,
            stroke: "none",
            strokeWidth: 0.264583,
            strokeOpacity: 1
          }}
          d="m 91.324658,20.007048 -0.04289,28.975492 15.069882,-0.0646 c 0,0 4.51592,-0.898127 5.99343,-2.32854 1.35674,-1.313489 2.26737,-3.045209 2.41484,-4.807458 0.1397,-1.669353 -0.0648,-3.969398 -1.05678,-5.282365 -1.01026,-1.337183 -4.44108,-2.436027 -4.44108,-2.436027 0,0 2.74212,-1.108231 3.6003,-2.263428 0.89734,-1.20792 1.29007,-2.959265 1.22887,-4.462777 -0.0737,-1.810726 -0.79574,-3.869465 -2.09083,-5.152657 -1.37837,-1.365711 -5.32526,-2.091345 -5.32526,-2.091345 z m 7.815027,5.488553 3.944465,0.110071 c 0,0 1.45992,0.258786 2.07171,0.63562 0.44682,0.275234 0.82961,0.678152 1.07848,1.132231 0.17386,0.317205 0.24459,0.690191 0.25528,1.049548 0.0142,0.476564 -0.024,0.987892 -0.25528,1.408183 -0.27165,0.493651 -0.76112,0.862464 -1.2485,1.160136 -0.54767,0.334495 -1.81643,0.663009 -1.81643,0.663009 l -4.058147,-0.110588 z m 0.01189,11.122319 4.237975,0.121956 c 0,0 1.56844,0.28524 2.22571,0.701249 0.48006,0.303848 0.8912,0.74877 1.15858,1.250053 0.18678,0.350182 0.26292,0.761869 0.27441,1.158586 0.0152,0.526106 -0.0259,1.090959 -0.27441,1.554944 -0.29185,0.544969 -0.8179,0.951924 -1.34152,1.280542 -0.58839,0.369267 -1.9513,0.731738 -1.9513,0.731738 l -4.359934,-0.121956 z"
        />
        <path
          style={{
            display: "inline",
            opacity: 1,
            fill: "#ffffff",
            fillOpacity: 1,
            stroke: "none",
            strokeWidth: 0.264583,
            strokeOpacity: 1
          }}
          d="M 116.86572,48.904934 V 20.061999 h 20.48885 l -0.061,5.579553 h -12.65308 l 0.0305,5.853957 11.86036,-0.06098 1e-5,5.549063 -11.92134,-1e-6 -2e-5,6.402765 13.23238,-0.03049 v 5.64053 z"
        />
      </g>
    </svg>
  );
}

export default Icon; 